<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<div class="figcenter1" id="Fig_Frontispiece">
<img alt="" class="calibre13" id="id-695928782557135104" src="Images/img0001.jpg"/>
<div class="caption" id="ebm_caption0"><p class="center1"><span class="smcap">Evil in such a Shape might be something more than Good.</span>
(<em class="calibre14">Frontispiece.</em>)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?29809c92